import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/functions";

import FirebaseAuth from "./auth";
import FirebaseAPI from "./api";
import PushClient from "./push-client";
import Analytics from "./analytics";

const firebaseConfigStaging = {
  apiKey: "AIzaSyDDtQ0smMg28ZSHYQFzXU1HDy8ktoUat5Y",
  authDomain: "eventzee-app-staging.firebaseapp.com",
  databaseURL: "https://eventzee-app-staging.firebaseio.com",
  projectId: "eventzee-app-staging",
  storageBucket: "eventzee-app-staging.appspot.com",
  messagingSenderId: "879985194690",
  appId: "1:879985194690:web:cc3eeda134b591335c6d5b",
  measurementId: "G-J3LH2DE6MR"
};

const firebaseConfigEventzee = {
  apiKey: "AIzaSyCunUjCuNJgEzPrDJjwWndPqhbc5qHd6lE",
  authDomain: "eventzee-app.firebaseapp.com",
  databaseURL: "https://eventzee-app.firebaseio.com",
  projectId: "eventzee-app",
  storageBucket: "eventzee-app.appspot.com",
  messagingSenderId: "386690991307",
  appId: "1:386690991307:web:6278edd8c335c1fb9b074e",
  measurementId: "G-7PNQ5S8CC7"
};

const firebaseConfigBarnesHD = {
  apiKey: "AIzaSyCTTlh-EqIr-XluB4TdvW-g2EobbRmI7Ts",
  authDomain: "eventzee-barnes.firebaseapp.com",
  databaseURL: "https://eventzee-barnes.firebaseio.com",
  projectId: "eventzee-barnes",
  storageBucket: "eventzee-barnes.appspot.com",
  messagingSenderId: "191848581312",
  appId: "1:191848581312:web:c24b17f7b05a9ccf248525",
  measurementId: "G-WWVWKF6621"
};

const firebaseConfigJupiter = {
  apiKey: "AIzaSyCiU7z9IzwO04vrMA2D-WeMxyumQDjg9Cs",
  authDomain: "eventzee---jupiter.firebaseapp.com",
  databaseURL: "https://eventzee---jupiter-default-rtdb.firebaseio.com",
  projectId: "eventzee---jupiter",
  storageBucket: "eventzee---jupiter.appspot.com",
  messagingSenderId: "170724363202",
  appId: "1:170724363202:web:92638b7fdb762a7195245b",
  measurementId: "G-M1M808X4EL"
};

const firebaseConfigHyatt = {
  apiKey: "AIzaSyBw-H2_EmbfSqiJs3fExUgrp-WcFxED35k",
  authDomain: "eventzee---hyatt.firebaseapp.com",
  databaseURL: "https://eventzee---hyatt-default-rtdb.firebaseio.com",
  projectId: "eventzee---hyatt",
  storageBucket: "eventzee---hyatt.appspot.com",
  messagingSenderId: "193013822738",
  appId: "1:193013822738:web:b40d0afd0c0151df46afcb"
};

const firebaseConfigQFive95 = {
  apiKey: "AIzaSyCCrxXpqz3yK7Ixz6Kbaj-yk8yeWMn3IQE",
  authDomain: "eventzee---qfive95-eu.firebaseapp.com",
  databaseURL:
    "https://eventzee---qfive95-eu-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "eventzee---qfive95-eu",
  storageBucket: "eventzee---qfive95-eu.appspot.com",
  messagingSenderId: "446282754412",
  appId: "1:446282754412:web:1e8ad34eaf445376e5eb49"
};

const firebaseConfigSevenPaths = {
  apiKey: "AIzaSyC5BmCsjsavOrp_qXIzq5Cc6gjTt_3c660",
  authDomain: "paths-city.firebaseapp.com",
  databaseURL: "https://paths-city-default-rtdb.firebaseio.com",
  projectId: "paths-city",
  storageBucket: "paths-city.appspot.com",
  messagingSenderId: "542360331270",
  appId: "1:542360331270:web:7c63f2366e3de595ce4f87",
  measurementId: "G-17LY7QV51W"
};

const firebaseConfigBahamar = {
  apiKey: "AIzaSyBAYU3v7KqJ3W2GMpXXLl2ZzWkTdF8SCqE",
  authDomain: "bahamar-7f6a7.firebaseapp.com",
  projectId: "bahamar-7f6a7",
  storageBucket: "bahamar-7f6a7.appspot.com",
  messagingSenderId: "780660503833",
  appId: "1:780660503833:web:a525c7f4fc279395cb8188",
  measurementId: "G-N5QYGSQR4G"
};

const firebaseConfigWellness = {
  apiKey: "AIzaSyDUm3EyeJV73PXcy1lwcpHB7539hok1hKs",
  authDomain: "eventzee---wellness.firebaseapp.com",
  projectId: "eventzee---wellness",
  storageBucket: "eventzee---wellness.appspot.com",
  messagingSenderId: "179659393671",
  appId: "1:179659393671:web:28ef626059b720b832c622",
  measurementId: "G-4NVGMHVXF7"
};

const firebaseConfigTeamBuilding = {
  apiKey: "AIzaSyA_KLZb3JWFTtvZ8H5KV6dePvoSJDavtY0",
  authDomain: "eventzee---team-building.firebaseapp.com",
  projectId: "eventzee---team-building",
  storageBucket: "eventzee---team-building.appspot.com",
  messagingSenderId: "756322372146",
  appId: "1:756322372146:web:04c15886048e49c1918a2b",
  measurementId: "G-3F315Q9BKT"
};

const firebaseConfigDowntown = {
  apiKey: "AIzaSyDpFj1QLokAP8bVD9l0kzu9vYjM3Y9eDG4",
  authDomain: "mydowntownapp.firebaseapp.com",
  projectId: "mydowntownapp",
  storageBucket: "mydowntownapp.firebasestorage.app",
  messagingSenderId: "951553941142",
  appId: "1:951553941142:web:760fb0981ffc49c5aeacb7",
  measurementId: "G-F0M6XC40NC"
};

export type Logger = import("./api").Logger & import("./auth").Logger;
export type Storage = import("./auth").Storage & import("./api").Storage;

export default class {
  api: FirebaseAPI;
  auth: FirebaseAuth;
  push: PushClient;
  analytics: Analytics;
  ready: Promise<void>;

  constructor(
    private logger: Logger,
    private storage: Storage,
    private onUserChanged?: () => void
  ) {
    let config;
    switch (process.env.REACT_APP_DEPLOYMENT) {
      case "eventzee":
        config = firebaseConfigEventzee;
        break;
      case "barneshd":
        config = firebaseConfigBarnesHD;
        break;
      case "jupiter":
        config = firebaseConfigJupiter;
        break;
      case "hyatt":
        config = firebaseConfigHyatt;
        break;
      case "qfive95":
        config = firebaseConfigQFive95;
        break;
      case "sevenpaths":
        config = firebaseConfigSevenPaths;
        break;
      case "bahamar":
        config = firebaseConfigBahamar;
        break;
      case "wellness":
        config = firebaseConfigWellness;
        break;
      case "downtown":
        config = firebaseConfigDowntown;
        break;
      case "teambuilding":
        config = firebaseConfigTeamBuilding;
        break;
      case "staging":
      default:
        config = firebaseConfigStaging;
        break;
    }
    firebase.default.initializeApp(config);
    this.api = new FirebaseAPI(this.logger, this.storage);
    this.auth = new FirebaseAuth(this.logger, this.onUserChanged);
    this.push = new PushClient();
    this.analytics = new Analytics();
    this.ready = this.init();
  }

  private async init() {}
}
